import UserStatusCongratulationsBenefitsCard from './UserStatusCongratulationsBenefitsCard';
import UserStatusWithdrawalLimitsNumbers
    from '../../components/UserStatusWIthdrawalLimits/UserStatusWithdrawalLimitsNumbers';
import { useSelector } from 'react-redux';
import { getUserStatusParamsSelector } from '../../../../app/userSelectors';
import { UserStatusCongratulationsBenefitsCardBadgeStyled } from './styled/UserStatusCongratulationsBenefitsCardStyled';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';

function UserStatusCongratulationsBenefitsWithdrawalLimits() {
    const { getLangPath } = useLangContext();
    const userStatusParams = useSelector(getUserStatusParamsSelector);

    return <UserStatusCongratulationsBenefitsCard
        badgeComponent={
            <UserStatusCongratulationsBenefitsCardBadgeStyled>
                {getLangPath('user_statuses.withdrawal_limits.no_fee_withdrawal')}
            </UserStatusCongratulationsBenefitsCardBadgeStyled>
        }
    >
        <UserStatusWithdrawalLimitsNumbers
            className={'text-start'}
            withdrawalLimits={userStatusParams?.withdrawalLimits}
        />
    </UserStatusCongratulationsBenefitsCard>;
}

export default UserStatusCongratulationsBenefitsWithdrawalLimits;
